import { render } from "./KryptonIdentityDocNumber.vue?vue&type=template&id=d87fbe98&lang=pug"
import script from "./KryptonIdentityDocNumber.vue?vue&type=script&lang=js"
export * from "./KryptonIdentityDocNumber.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__